import CoffeeBreakT1 from "@/components/CoffeeBreakT1.vue";
import CoffeeBreakT2 from "@/components/CoffeeBreakT2.vue";
import CoffeeBreakT3 from "@/components/CoffeeBreakT3.vue";
import Brunch from "@/components/Brunch.vue";
import KitLanche from "@/components/KitLanche.vue";

import * as utils from "@/utils/utils.js";
import { axiosBuffet } from "@/services/axiosInstances";
import MaskDirectives from "@/directives/masks";

export default {
  props: ["updateSistema"],
  name: "BuffetPage",

  components: {
    CoffeeBreakT1,
    CoffeeBreakT2,
    CoffeeBreakT3,
    Brunch,
    KitLanche
  },

  directives: MaskDirectives.directives,

  data() {
    return {
      solicitacao: {
        tituloEvento: null,
        justificativaSolicitacao: null,
        dataEvento: null,
        horarioEvento: null,
        localEvento: null,
        endereco: null,
        complemento: null,
        servidorResponsavel: null,
        matriculaServidorResponsavel: null,
        emailServidorResponsavel: null,
        telefoneServidorResponsavel: null,
        numeroSEC: null,
        qtdePessoas: null,
        tipoBuffet: null,
        valorSolicitacao: null,
        cardapio: { tipoCardapio: null },
      },

      // solicitacao: {
      //   tituloEvento: 'Calourada 2026',
      //   justificativaSolicitacao: 'Receber bem os alunos',
      //   dataEvento: '2026-03-25',
      //   horarioEvento: '08:00',
      //   localEvento: 'Praça da Paz',
      //   endereco: 'Rua Roxo Moreira, no final da rua',
      //   complemento: 'Praça',
      //   servidorResponsavel: 'Ricardo',
      //   matriculaServidorResponsavel: '286121',
      //   emailServidorResponsavel: 'ricardob@unicamp.br',
      //   telefoneServidorResponsavel: '(19) 3521-7166',
      //   numeroSEC: '12345/2026',
      //   qtdePessoas: 30,
      //   tipoBuffet: null,
      //   valorSolicitacao: 20,
      //   cardapio: { tipoCardapio: null },
      // },

      dataMinima: utils.formatarDataISO(utils.calcularDataMinima(12)),

      valorPorPessoa: null,

      precos: [],
      errosDadosGerais: [],
      errosDadosCardapio: [],

      isConfirmado: false,
      isContinuar: false,

      cardapioKey: 0, // Chave inicial
    };
  },

  methods: {
    goHome() {
      this.$router.push({ name: "servicos" });
    },

    receberEmitCardapio(value) {
      this.solicitacao.cardapio = value;
    },

    continuar() {
      var validarDadosGerais = this.validarDadosGerais();

      if (true && validarDadosGerais) {
        this.isContinuar = true;
      }
    },

    // função para enviar os dados do formulário
    enviarSolicitacao() {
      this.atualizarTipoCardapio();
      console.log(JSON.stringify(this.solicitacao));

      if (!this.isConfirmado) {
        this.$swal.fire({
          title: "Oops",
          html: "Por favor confirme se todos os dados informados estão corretos antes de enviar a solicitação.",
          icon: "error",
        });
        return;
      }

      var tipoBuffet = this.getCodigoTipoBuffet();

      var validarCardapio = this.validarCardapio(tipoBuffet);
      var validarDadosGerais = this.validarDadosGerais();
      var validarNumeroSEC = this.validarNumeroSEC();

      if (true && validarDadosGerais && validarCardapio && validarNumeroSEC) {
        axiosBuffet
          .post("/cadastro", this.solicitacao)
          .then((response) => {
            let msg =
              "Você receberá um e-mail de confirmação das informações registradas com a solicitação em PDF para que possa anexá-la à SEC no SIAD. <br /><br />Caso prefira, faça o download da solicitação clicando no botão abaixo.'";

            console.log("ID: " + response.data.id);

            this.$swal
              .fire({
                title: "Sua solicitação foi enviada",
                html: msg,
                icon: "success",
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: true,
                focusConfirm: true,
                showDenyButton: true,
                confirmButtonText: "Fazer download agora",
                denyButtonText: "Não quero fazer o download",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.downloadSolicitacao(response.data.id);
                  this.$router.push("/");
                } else if (result.isDenied) {
                  this.$router.push("/");
                }
              });
          })
          .catch((error) => {
            console.log(error);
            this.$swal
              .fire({
                title: "Erro ocorrido",
                html: "Ocorreu um erro durante o cadastro!",
                icon: "error",
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: true,
                focusConfirm: true,
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.$router.push("/");
                }
              });
          });
      } else {
        this.$swal.fire({
          title: "Oops",
          html: "Sua solicitação está com algum problema de preenchimento. Por favor, verifique todos os campos.",
          icon: "error",
        });
      }
    },

    getCodigoTipoBuffet() {
      if (this.solicitacao.tipoBuffet === "Coffee Break Tipo 1") {
        return 1;
      } else if (this.solicitacao.tipoBuffet === "Coffee Break Tipo 2") {
        return 2;
      } else if (this.solicitacao.tipoBuffet === "Coffee Break Tipo 3") {
        return 3;
      } else if (this.solicitacao.tipoBuffet === "Brunch") {
        return 4;
      } else if (this.solicitacao.tipoBuffet === "Kit Lanche") {
        return 5;
      }
    },

    getPrecoPorPessoa(idTipoCardapio) {
      const item = this.precos.find(
        (preco) => preco.idTipoCardapio == idTipoCardapio
      );

      return item ? item.precoPorPessoa : null;
    },

    // função para validar os dados do bloco dados gerais
    validarDadosGerais() {
      this.errosDadosGerais = [];

      let solicitacao = this.solicitacao;

      if (!solicitacao.tituloEvento) {
        this.errosDadosGerais.push('Campo "Título do Evento" é obrigatório.');
      }

      if (!solicitacao.justificativaSolicitacao) {
        this.errosDadosGerais.push('Campo "Justificativa da Solicitacao" é obrigatório.');
      }

      if (!solicitacao.dataEvento) {
        this.errosDadosGerais.push('Campo "Data do Evento" é obrigatório.');
      } else {
        if (solicitacao.dataEvento < this.dataMinima) {
          this.errosDadosGerais.push(
            'Campo "Data do Evento" deve ser no mínimo 16 dias de antecedência. Data Mínima = ' +
              this.formatarData(this.dataMinima)
          );
        }
      }
      if (!solicitacao.horarioEvento) {
        this.errosDadosGerais.push(
          'Campo "Horário para Início do Buffet" é obrigatório.'
        );
      }
      else {
        const horario = solicitacao.horarioEvento;

        // Valida formato HH:mm
        const regexHora = /^([01]\d|2[0-3]):([0-5]\d)$/;

        if (!regexHora.test(horario)) {
          this.errosDadosGerais.push(
            'Horário inválido. Utilize o formato HH:mm.'
          );
        } else {
          const [hora, minuto] = horario.split(":").map(Number);
          const totalMinutos = hora * 60 + minuto;

          const minPermitido = 7 * 60;   // 07:00
          const maxPermitido = 20 * 60;  // 20:00

          if (totalMinutos < minPermitido || totalMinutos > maxPermitido) {
            this.errosDadosGerais.push(
              'O horário do evento deve estar entre 07:00 e 20:00.'
            );
          }
        }
      }

      if (!solicitacao.localEvento) {
        this.errosDadosGerais.push('Campo "Local do Evento" é obrigatório.');
      }
      if (!solicitacao.endereco) {
        this.errosDadosGerais.push('Campo "Endereço" é obrigatório.');
      }
      if (!solicitacao.complemento) {
        this.errosDadosGerais.push('Campo "Complemento" é obrigatório.');
      }
      if (!solicitacao.qtdePessoas) {
        this.errosDadosGerais.push(
          'Campo "Quantidade de Pessoas a Serem Atendidas" é obrigatório.'
        );
      } else if (solicitacao.qtdePessoas < 20) {
        this.errosDadosGerais.push(
          'Campo "Quantidade de Pessoas a Serem Atendidas" deve ser no mínimo 20.'
        );
      }
      if (!solicitacao.servidorResponsavel) {
        this.errosDadosGerais.push(
          'Campo "Servidor Responsavel pela Fiscalização" é obrigatório.'
        );
      }
      if (!solicitacao.emailServidorResponsavel) {
        this.errosDadosGerais.push(
          'Campo "Email do Servidor Responsavel" é obrigatório.'
        );
      } else if (!utils.validarEmail(solicitacao.emailServidorResponsavel)) {
        this.errosDadosGerais.push(
          'Campo "E-mail do Servidor Responsável" não está válido.'
        );
      }
      if (!solicitacao.telefoneServidorResponsavel) {
        this.errosDadosGerais.push(
          'Campo "Telefone do Servidor Responsável" é obrigatório.'
        );
      }
      // if (!solicitacao.numeroSEC) {
      //     this.errosDadosGerais.push('Campo "Número da SEC" é obrigatório.');
      // }

      return this.errosDadosGerais.length === 0;
    },

    // método a parte para verificar o numero da SEC
    validarNumeroSEC() {
      if (!this.solicitacao.numeroSEC) {
        this.errosDadosGerais.push('Campo "Número da SEC" é obrigatório.');
      }

      return this.errosDadosGerais.length === 0;
    },

    validarCardapio(tipoBuffet) {
      switch (tipoBuffet) {
        case 1:
          return this.validarCardapioCoffeeBreakT1();
        case 2:
          return this.validarCardapioCoffeeBreakT2();
        case 3:
          return this.validarCardapioCoffeeBreakT3();
        case 4:
          return this.validarCardapioBrunch();          
        case 5:
          return this.validarCardapioKitLanche();              
        default:
          break;
      }
    },
    
    // função para validar o coffee break tipo 1
    validarCardapioCoffeeBreakT1() {
      this.errosDadosCardapio = [];

      let cardapio = this.solicitacao.cardapio;

      if (!cardapio) {
        this.errosDadosCardapio.push("O cardápio não foi preenchido.");
      } else {
        if (!cardapio.agua) {
          this.errosDadosCardapio.push('Campo "Água" é obrigatório.');
        }
        if (!cardapio.cafe) {
          this.errosDadosCardapio.push('Campo "Café Sem Açúcar" é obrigatório.');
        }
        if (!cardapio.sucos || cardapio.sucos.length != 2 ) {
          this.errosDadosCardapio.push(
            'Campo "Néctar de Frutas" é obrigatório e é necessário selecionar 2 opções.'
          );
        }
        if (!cardapio.cha) {
          this.errosDadosCardapio.push('Campo "Chá Matte" é obrigatório.');
        }
        if (!cardapio.assado) {
          this.errosDadosCardapio.push('Campo "Salgados Assados" é obrigatório.');
        }
        if (!cardapio.sanduiche) {
          this.errosDadosCardapio.push('Campo "Sanduíche no Brioche" é obrigatório.');
        }
        if (!cardapio.bolos || cardapio.bolos.length != 2 ) {
          this.errosDadosCardapio.push(
            'Campo "Bolos" é obrigatório e é necessário selecionar 2 opções.'
          );
        }
      }
      return this.errosDadosCardapio.length == 0;
    },

    // função para validar o coffee break tipo 2
    validarCardapioCoffeeBreakT2() {
      this.errosDadosCardapio = [];

      let cardapio = this.solicitacao.cardapio;

      if (!cardapio) {
        this.errosDadosCardapio.push("O cardápio não foi preenchido.");
      } else {
        if (!cardapio.agua) {
          this.errosDadosCardapio.push('Campo "Água" é obrigatório.');
        }
        if (!cardapio.cafe) {
          this.errosDadosCardapio.push('Campo "Café" é obrigatório.');
        }
        if (!cardapio.sucos || cardapio.sucos.length != 2 ) {
          this.errosDadosCardapio.push(
            'Campo "Néctar de Frutas" é obrigatório e é necessário selecionar 2 opções.'
          );
        }
        if (!cardapio.cha) {
          this.errosDadosCardapio.push('Campo "Chá Matte" é obrigatório.');
        }
        if (!cardapio.assados || cardapio.assados.length != 2 ) {
          this.errosDadosCardapio.push(
            'Campo "Salgados Assados" é obrigatório e é necessário selecionar 2 opções.'
          );
        }
        if (!cardapio.vegetariano) {
          this.errosDadosCardapio.push('Campo "Salgados Assados Vegetariano" é obrigatório.');
        }
        if (!cardapio.sanduiche_I) {
          this.errosDadosCardapio.push('Campo "Sanduíche Individual de Mini Pão de Leite" é obrigatório.');
        }
        if (!cardapio.sanduiche_B) {
          this.errosDadosCardapio.push('Campo "Sanduíche na Baguete" é obrigatório.');
        }
        if (!cardapio.doce) {
          this.errosDadosCardapio.push('Campo "Doces Individuais" é obrigatório.');
        }
        if (!cardapio.bolo) {
          this.errosDadosCardapio.push('Campo "Bolo" é obrigatório.');
        }
        if (!cardapio.frutas || cardapio.frutas.length != 4 ) {
          this.errosDadosCardapio.push(
            'Campo "Salada de Frutas" é obrigatório e é necessário selecionar 4 opções.'
          );
        }
      }
      return this.errosDadosCardapio.length == 0;
    },

    // função para validar o coffee break tipo 3
    validarCardapioCoffeeBreakT3() {
      this.errosDadosCardapio = [];

      let cardapio = this.solicitacao.cardapio;

      if (!cardapio) {
        this.errosDadosCardapio.push("O cardápio não foi preenchido.");
      } else {
        if (!cardapio.agua) {
          this.errosDadosCardapio.push('Campo "Água" é obrigatório.');
        }
        if (!cardapio.cafe) {
          this.errosDadosCardapio.push('Campo "Café Sem Açúcar" é obrigatório.');
        }
        if (!cardapio.sucos || cardapio.sucos.length != 2 ) {
          this.errosDadosCardapio.push(
            'Campo "Néctar de Frutas" é obrigatório e é necessário selecionar 2 opções.'
          );
        }
        if (!cardapio.cha) {
          this.errosDadosCardapio.push('Campo "Chá Matte" é obrigatório.');
        }
        if (!cardapio.assados || cardapio.assados.length != 2 ) {
          this.errosDadosCardapio.push(
            'Campo "Salgados Assados" é obrigatório e é necessário selecionar 2 opções.'
          );
        }
        if (!cardapio.vegetariano) {
          this.errosDadosCardapio.push('Campo "Salgados Assados Vegetariano" é obrigatório.');
        }
        if (!cardapio.lanche) {
          this.errosDadosCardapio.push('Campo "Lanche no Pão de Forma Integral" é obrigatório.');
        }
        if (!cardapio.sanduiche_B) {
          this.errosDadosCardapio.push('Campo "Sanduíche na Baguete" é obrigatório.');
        }
        if (!cardapio.sanduiche_C) {
          this.errosDadosCardapio.push('Campo "Sanduíche na Ciabatta" é obrigatório.');
        }
        if (!cardapio.doces || cardapio.doces.length != 2 ) {
          this.errosDadosCardapio.push(
            'Campo "Doces Individuais" é obrigatório e é necessário selecionar 2 opções.'
          );
        }
        if (!cardapio.bolo) {
          this.errosDadosCardapio.push('Campo "Bolo" é obrigatório.');
        }
        if (!cardapio.frutas || cardapio.frutas.length != 4 ) {
          this.errosDadosCardapio.push(
            'Campo "Salada de Frutas" é obrigatório e é necessário selecionar 4 opções.'
          );
        }
      }
      return this.errosDadosCardapio.length == 0;
    },

    // função para validar o brunch
    validarCardapioBrunch() {
      this.errosDadosCardapio = [];

      let cardapio = this.solicitacao.cardapio;

      if (!cardapio) {
        this.errosDadosCardapio.push("O cardápio não foi preenchido.");
      } else {
        if (!cardapio.agua) {
          this.errosDadosCardapio.push('Campo "Água" é obrigatório.');
        }
        if (!cardapio.cafe) {
          this.errosDadosCardapio.push('Campo "Café Sem Açúcar" é obrigatório.');
        }
        if (!cardapio.sucos || cardapio.sucos.length != 2 ) {
          this.errosDadosCardapio.push(
            'Campo "Néctar de Frutas" é obrigatório e é necessário selecionar 2 opções.'
          );
        }
        if (!cardapio.cha) {
          this.errosDadosCardapio.push('Campo "Chá Matte" é obrigatório.');
        }
        if (!cardapio.fingerFoods || cardapio.fingerFoods.length != 2 ) {
          this.errosDadosCardapio.push(
            'Campo "Finger Foods" é obrigatório e é necessário selecionar 2 opções.'
          );
        }
        if (!cardapio.caldosSopas || cardapio.caldosSopas.length != 2 ) {
          this.errosDadosCardapio.push(
            'Campo "Caldos e Sopas" é obrigatório e é necessário selecionar 2 opções.'
          );
        }
        if (!cardapio.salada) {
          this.errosDadosCardapio.push('Campo "Saladas" é obrigatório.');
        }
        if (!cardapio.torrada) {
          this.errosDadosCardapio.push('Campo "Torradas" é obrigatório.');
        }
        if (!cardapio.pates || cardapio.pates.length != 2 ) {
          this.errosDadosCardapio.push(
            'Campo "Patês" é obrigatório e é necessário selecionar 2 opções.'
          );
        }
        if (!cardapio.doces || cardapio.doces.length != 2 ) {
          this.errosDadosCardapio.push(
            'Campo "Doces Individuais" é obrigatório e é necessário selecionar 2 opções.'
          );
        }
        if (!cardapio.frutas || cardapio.frutas.length != 4 ) {
          this.errosDadosCardapio.push(
            'Campo "Salada de Frutas" é obrigatório e é necessário selecionar 4 opções.'
          );
        }
      }
      return this.errosDadosCardapio.length == 0;
    },

    // função para validar o kit lanche
    validarCardapioKitLanche() {
      this.errosDadosCardapio = [];

      let cardapio = this.solicitacao.cardapio;

      if (!cardapio) {
        this.errosDadosCardapio.push("O cardápio não foi preenchido.");
      } else {
        if (!cardapio.pao) {
          this.errosDadosCardapio.push('Campo "Pão de Leite (50g)" é obrigatório.');
        }
        if (!cardapio.suco) {
          this.errosDadosCardapio.push('Campo "Néctar de Frutas" é obrigatório.');
        }
        if (!cardapio.bolo) {
          this.errosDadosCardapio.push('Campo "Bolo Individual" é obrigatório.');
        }
        if (!cardapio.fruta) {
          this.errosDadosCardapio.push('Campo "Fruta" é obrigatório.');
        }        
        if (!cardapio.barraCereal) {
          this.errosDadosCardapio.push('Campo "Barra de Cereal" é obrigatório.');
        }
      }
      return this.errosDadosCardapio.length == 0;
    },


    async carregarPrecos() {
      try {
        const resposta = await axiosBuffet.get("/precos");
        this.precos = resposta.data;
      } catch (erro) {
        console.error(`Erro ao buscar ${this.entidade}:`, erro);
      }
    },

    atualizarValorSolicitacao() {
      let idTipoCardapio = this.solicitacao.cardapio.tipoCardapio;

      this.valorPorPessoa = this.getPrecoPorPessoa(idTipoCardapio);
      this.solicitacao.valorSolicitacao =
        this.valorPorPessoa * this.solicitacao.qtdePessoas;
    },

    atualizarTipoCardapio() {
      this.solicitacao.cardapio.tipoCardapio = this.getCodigoTipoBuffet();
    },

    resetDadosCardapio() {
      this.solicitacao.cardapio = {
        tipoCardapio: 0
      };
    },

    handleChangeTipoBuffet() {
      // Reseta o componente ao alterar a chave
      this.cardapioKey++;

      this.resetDadosCardapio();
      this.atualizarTipoCardapio();
      this.atualizarValorSolicitacao();

    },

    async downloadSolicitacao(id) {
      try {
        const response = await axiosBuffet.get(`/download/${id}`, {
          responseType: "arraybuffer", // Trata a resposta como um arquivo binário
        });

        // Criar um Blob a partir da resposta de PDF
        const pdfBlob = new Blob([response.data], { type: "application/pdf" });

        // Criar uma URL temporária para o Blob
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Criar um link de download e simular um clique para forçar o download do PDF
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = `relatorio_${id}.pdf`; // Define o nome do arquivo para o download

        // Adiciona o link ao corpo do documento para que o clique funcione
        document.body.appendChild(link);
        link.click(); // Simula o clique

        // Remove o link do DOM após o download
        document.body.removeChild(link);

        // Liberar a URL temporária criada
        URL.revokeObjectURL(pdfUrl);
      } catch (error) {
        console.error("Erro ao fazer o download do PDF:", error);
      }
    },

    formatarData(dataISO) {
      if (!dataISO) return "";

      const [ano, mes, dia] = dataISO.split("-");
      return `${dia}/${mes}/${ano}`;
    },

    ajustarDataMinima() {
      if (
        !this.solicitacao.dataEvento ||
        this.solicitacao.dataEvento < this.dataMinima
      ) {
        this.solicitacao.dataEvento = this.dataMinima;
      }
    },

    validarData() {
      if (this.solicitacao.dataEvento < this.dataMinima) {
        this.$swal.fire({
          title: "Oops",
          html:
            "A data mínima para solicitação é 12 dias antes do evento. (Data Mínima:  " +
            this.formatarData(this.dataMinima) +
            ").",
          icon: "warning",
        });
        this.solicitacao.dataEvento = this.dataMinima;
      } else {
        console.log("ok");
      }
    },
  },

  computed: {
    valorPorPessoaFormatado() {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(this.valorPorPessoa);
    },

    valoDaSolicitacaoFormatado() {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(this.solicitacao.valorSolicitacao);
    },
  },

  watch: {
    "solicitacao.qtdePessoas": "atualizarValorSolicitacao",
    "solicitacao.tipoBuffet": "atualizarValorSolicitacao",
  },

  created() {
    this.carregarPrecos();
  },

  mounted() {},
};
